import type { ReactNode } from 'react';
import classnames from 'classnames';

interface IPageSectionProps {
    backgroundColor?: string;
    children: ReactNode;
    className?: string;
}

export function Main(props: Readonly<IPageSectionProps>) {
    return (
        <div
            className={classnames('main', props.className ?? '')}
            style={{ backgroundColor: props.backgroundColor }}
        >
            {props.children}
        </div>
    );
}
